import { LILAC_500, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getCompareBenefitListV2Styles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_12 = _tokens$spacing.SPACING_12;
  return StyleSheet.create({
    compareBenefitItem: {
      paddingHorizontal: SPACING_12,
      paddingVertical: SPACING_12,
      borderColor: LILAC_500,
      alignItems: 'flex-start'
    },
    tableRowWrapper: {
      flexDirection: 'row'
    },
    packcard: {
      margin: SPACING_0
    },
    cellContainer: {
      flexDirection: 'row',
      flex: 1
    }
  });
};